import React, { Component } from "react";
import ReactTable from "react-table";
import { Select, Segment, Grid, Header, Confirm, Loader, Divider } from "semantic-ui-react";
import { StatsBox } from "../../components/common/StatsBox";
import DropzoneCommon from "../../components/content/DropzoneCommon";
import request from "../../utils/request";

const columns = [
  {
    Header: "File Name",
    accessor: "filename",
    width: 225
  },
  {
    Header: "Type",
    accessor: "type"
  },
  {
    Header: "Count",
    accessor: "record_count"
  },
  {
    Header: "Status",
    accessor: d => (d.status === "processing") ?
      <>
        <Loader active inline='centered' size='mini' />{d.status}
      </> :
      d.status,
    id: "status",
    style: { textAlign: "center" }
  },
  {
    Header: "Created At",
    accessor: "created_at"
  }
];

class EventImporter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summary: {},
      isLoading: true,
      importType: "",
      pollInterval: false,
      imports: [],
      openConfirmUpload: false,
      file: {}
    };
  }

  componentDidMount = () => {
    this.fetchImports();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.pollInterval);
  }

  getSummary = () => {
    request
      .get(this, `api:/event/${this.props.eventId}/summary`)
      .then(eventSummary => {
        this.setState({ summary: eventSummary });
      });
  }

  fetchImports = () => {
    let payload = {
      limit: 1000,
      ts: Date.now()
    };
    return request
      .get(this, `api:/event/${this.props.eventId}/import`, payload)
      .then(response => {

        this.setState({
          isLoading: false,
          imports: response && response.status !== "error" ? response : []
        }, () => this.handlePoll());

        this.getSummary();
      });
  }

  handlePoll = () => {
    if (!this.state.pollInterval) {
      let poll = setInterval(this.fetchImports, 15000);
      this.setState({
        pollInterval: poll
      });
    }
  };

  handleImportType = (e, { name, value }) => {
    this.setState({ importType: value });
  };

  handleDrop = files => {
    let self = this;
    self.setState({ openConfirmUpload: true, file: files[0] });
  };

  handleUpload = () => {
    this.setState({ isLoading: true, openConfirmUpload: false });

    const { file, importType } = this.state;
    const formData = new FormData();

    formData.append("importFile", file);
    formData.append("type", importType);
    formData.append("mode", "import");

    return request
      .post(this, `api:/event/${this.props.eventId}/import`, formData, this.fetchImports, 120000)
  }

  closeConfirmUpload = () => {
    this.setState({ openConfirmUpload: false });
  }

  render() {
    const { importType, isLoading, imports, openConfirmUpload, file, summary } = this.state;

    let importTypeOptions = [
        { value: "sales", text: "Sales" },
        { value: "voids", text: "Voids" },
        { value: "prizes", text: "Prizes" }
    ];
    if (summary && summary.prize_imports_enabled > 0 && summary.is_import_raffle < 1)
        importTypeOptions = importTypeOptions.filter(function(option) {
            return option && option.value === "prizes";
        });

    const confirmMessage = (file && <Segment basic>
      <Header as="h3">Upload Confirmation: <b style={{ color: "red" }}>Please Read Below</b></Header>
      <Header as="h4">File Name: <b style={{ color: "red" }}>{file.name}</b></Header>
      <Header as="h4">Import Type: <b style={{ color: "red", textTransform: "uppercase" }}>{importType}</b></Header>
      <Header as="h4">This action cannot be undone, please select 'Confirm' to proceed with upload.</Header>
    </Segment>);

    return (
      <Segment basic loading={isLoading}>
        {file && <Confirm
          open={openConfirmUpload}
          content={confirmMessage}
          confirmButton='Confirm'
          size="tiny"
          onCancel={this.closeConfirmUpload}
          onConfirm={this.handleUpload}
        />}
        <Select
          name="importType"
          placeholder="Import Type"
          value={importType}
          options={importTypeOptions}
          onChange={this.handleImportType}
        />
        <br /><br />
        {importType !== "" && <>
          <Header as="h3">{`Import ${importType}`}</Header>
          <DropzoneCommon
            onDrop={this.handleDrop}
            accept="text/csv"
            className="ui segment"
            multiple={false}
          />
        </>}
        <ReactTable
          data={imports}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable={true}
          defaultPageSize={20}
          minRows={0}
        />
        <Segment basic />
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Segment>
            <Header>Details</Header>
            <Grid columns={3}>
              <Grid.Column>
                <StatsBox
                  label="Gross Numbers"
                  value={summary.tickets ? summary.tickets.total : 0}
                />
              </Grid.Column>
              <Grid.Column>
                <StatsBox
                  label="Void Numbers"
                  value={summary.tickets ? summary.tickets.voids : 0}
                />
              </Grid.Column>
              <Grid.Column>
                <StatsBox
                  label="Net Numbers"
                  value={summary.tickets ? summary.tickets.net : 0}
                />
              </Grid.Column>
            </Grid>
          </Segment>
        </Grid.Column>
      </Segment>
    );
  }
}

export default EventImporter;
